<template>
  <div class="managingPeople hp100 bbox" v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row :gutter="20" type="flex" justify="space-between">
        <!-- <el-col>
                    <el-button plain class="add-column-btn bbox" @click="gotoDetail('')" type="primary"> <i class="el-icon-plus fw900 f16"></i> 新增</el-button>
                </el-col> -->
        <el-col><span style="font-size: 14px; padding-right: 20px">进货单查询</span><span
            style="font-size: 12px; padding-right: 20px">[&nbsp;日期：<span
              id="showStartDt"></span>&nbsp;&nbsp;至&nbsp;&nbsp;<span id="showEndDt"></span>&nbsp;]</span></el-col>
        <el-col>
          <!-- <div class="flex align-center justify-end header-search-box">
                        <el-input
                                placeholder="查询条件"
                                clearable
                                v-model="searchInput"
                                class="header-search-input ml10"
                        >
                            <el-button
                                    slot="append"
                                    icon="el-icon-search"
                                    class="textblue searchBtn"
                                    @click="search()"
                            ></el-button>
                        </el-input>
                    </div> -->
          <div class="block">
            <div style="font-size: 12px; line-height: 30px; padding-right: 10px">
              单据时间
            </div>
            <el-date-picker prefix-icon="''" v-model="dateRange" value-format="yyyy-MM-dd" type="daterange"
              range-separator="-" start-placeholder="yyyy-MM-dd" end-placeholder="yyyy-MM-dd">
            </el-date-picker>
            <div class="search-btn" @click="search()" style="margin-left:55px">
              <!-- <el-button type="primary"  @click="search()">搜索</el-button> -->
              <i class="el-icon-refresh-right" style="font-size: 20px"></i>查询
            </div>
          </div>
        </el-col>
        <!-- <el-col></el-col> -->
      </el-row>
      <!-- 用户列表区域 -->
      <!-- <div :style="{ height: height + 'px' }" style=" margin-top: 20px;"> -->

      <!-- 边框层 -->
      <el-table @row-click="showDetail" show-summary :summary-method="getSummaries" :header-cell-style="{
        background: '#f59a23',
        color: '#fff'
      }" height="260px" style="width: 100%;" :data="tableData" border fit highlight-current-row
        @sort-change="sortChange">
        <el-table-column type="index" width="50" align="center">
          <template slot="header"><i class="el-icon-s-tools"></i></template>
        </el-table-column>
        <el-table-column label="日期" align="center" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.billTime | dataFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单编号" align="center" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.billNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column label="供货商" align="center" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.contactOrganName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="收货仓库" align="center" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.companyName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="经手人" align="center" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.hander }}</span>
          </template>
        </el-table-column>
        <el-table-column label="单据金额" align="center" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.dealFee }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品数量" align="center" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.productNum }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage" :page-sizes="[10, 20, 30, 50]" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
      <!-- 表格2 -->
      <div style="font-size: 14px; margin-top: 20px">
        商品明细 |当前单据号
        <span>{{
          productDetail.length == 0 ? "" : productDetail[0].enterBillCode
          }}</span>
      </div>
      <el-table show-summary :summary-method="getSummariesBottom"
        :header-cell-style="{ background: '#f59a23', color: '#fff' }" :data="productDetail" border highlight-current-row
        height="160px" @sort-change="sortChange">
        <el-table-column type="index" align="center" width="50">
          <template slot="header"><i class="el-icon-s-tools"></i></template>
        </el-table-column>
        <el-table-column prop="productCode" label="商品编号" align="center"></el-table-column>
        <el-table-column prop="productName" label="商品名称" align="center"></el-table-column>
        <el-table-column prop="format" label="规格" align="center"></el-table-column>
        <el-table-column prop="unit" label="单位" align="center"></el-table-column>
        <el-table-column prop="num" label="数量" align="center"></el-table-column>
        <el-table-column prop="remainStockNum" label="入库后库存" align="center"></el-table-column>
        <el-table-column prop="purchasePrice" label="进价" align="center"></el-table-column>
        <el-table-column prop="subtotal" label="小计" align="center"></el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.currPage" :page-sizes="[10, 20, 30, 50]" :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="productDetailTotal"></el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      productDetailTotal: 1,
      firstRow: true,
      productDetail: [],
      height: window.innerHeight - 256, //表格高度
      value: "",
      dateRange: "",
      endDate: "",
      startDate: "",

      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          id: "",
          endDt: "",
          startDt: ""
        }
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: ""
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false
    };
  },
  created() {
    this.queryInfo.currPage = this.$route.query.currPage;
    this.queryInfo.pageSize = this.$route.query.pageSize;
    this.getListData();
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    //点击行时间
    showDetail(row) {
      this.queryInfo.condition.companyCode = localStorage.getItem(
        "merchantCode"
      );
      this.queryInfo.condition.enterBillCode = row.enterBillCode;
      if (this.dateRange != null && this.dateRange.length != 0) {
        this.queryInfo.condition.startDt = this.dateRange[0];
        this.queryInfo.condition.endDt = this.dateRange[1];
      } else {
        this.queryInfo.condition.startDt = "";
        this.queryInfo.condition.endDt = "";
      }
      this.$http
        .post("/purchaseEnterBillDetails/list", this.queryInfo)
        .then(res => {
          this.productDetail = res.data.data.data;
          this.productDetailTotal = res.data.data.count;
        });
    },
    // 求和表1
    getSummaries(param) {
      const { columns, data } = param;
      let dealFeeSum = 0;
      let productNumSum = 0;
      data.forEach(item => {
        productNumSum += item.productNum;
        dealFeeSum += item.dealFee;
      });
      return ["合计", "", "", "", "", "", dealFeeSum, productNumSum];
    },
    //求和表2
    getSummariesBottom(param) {
      const { columns, data } = param;
      let arr = [];
      let num = 0;
      let purchasePrice = 0;
      let remainStockNum = 0;
      let subtotal = 0;
      data.forEach(item => {
        num += item.num;
        purchasePrice += item.purchasePrice;
        remainStockNum += item.remainStockNum;
        subtotal += item.subtotal;
        console.log(num, item.num);
      });
      return [
        "合计",
        "",
        "",
        "",
        "",
        num.toFixed(2),
        remainStockNum.toFixed(2),
        purchasePrice.toFixed(2),
        subtotal.toFixed(2)
      ];
    },
    //条件查询
    search() {
      this.queryInfo.condition.id = this.searchInput;
      var arr = [];
      arr = this.dateRange.toString().split(",");
      this.startDate = arr[0];
      this.endDate = arr[1];

      console.log("this.startDate" + this.startDate);
      console.log("this.endDate" + this.endDate);
      this.queryInfo.condition.startDt = arr[0];
      this.queryInfo.condition.endDt = arr[1];
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() { },
    //跳转到详情
    gotoDetail(id) {
      var that = this;
      this.$router.push({
        path: "/merchantOrder/details",
        query: {
          id: id,
          currPage: that.queryInfo.currPage,
          pageSize: that.queryInfo.pageSize
        }
      });
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(err => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/merchantOrders/delete", { id: id })
          .then(function (response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true
            });
            that.getListData();
          });
      }
    },
    getListData() {
      // 获取列表
      var that = this;
      that.queryInfo.condition.companyCode = localStorage.getItem(
        "merchantCode"
      );
      that.queryInfo.condition.enterBillCode = "";
      if (that.dateRange != null && that.dateRange.length != 0) {
        that.queryInfo.condition.startDt = that.dateRange[0];
        that.queryInfo.condition.endDt = that.dateRange[1];
      } else {
        that.queryInfo.condition.startDt = "";
        that.queryInfo.condition.endDt = "";
      }
      that.$http
        .post("/purchaseEnterBills/list", that.queryInfo)
        .then(function (response) {
          console.log(response.data.data, "列表查询");
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
            console.log("getList", that.tableData[0].enterBillCode);
            //首次加载表2显示首行数据
            if (that.firstRow == true) {
              that.firstRow = false;
              that.queryInfo.condition.companyCode = localStorage.getItem(
                "merchantCode"
              );
              that.queryInfo.condition.enterBillCode =
                that.tableData[0].enterBillCode;
              if (that.dateRange != null && that.dateRange.length != 0) {
                that.queryInfo.condition.startDt = that.dateRange[0];
                that.queryInfo.condition.endDt = that.dateRange[1];
              } else {
                that.queryInfo.condition.startDt = "";
                that.queryInfo.condition.endDt = "";
              }
              that.$http
                .post("/purchaseEnterBillDetails/list", that.queryInfo)
                .then(res => {
                  that.productDetail = res.data.data.data;
                });
            }
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    }
  }
};
</script>

<style lang="less" scoped>
.block {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

.search-btn {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translateX(-45px);
  // margin-left: 10px;
}

.textblue {
  color: #008eff;
}

.managingPeople {
  .el-card {
    // height: calc(100vh - 114px);
    position: relative;

    .el-select>.el-input {
      width: 200px;
    }

    .header-search-box .header-search-input {
      width: 325px;
    }

    input::placeholder {
      font-size: 12px;
    }

    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }

    // .footerBox {
    //     display: block;
    //     position: absolute;
    //     width: 100%;
    //     height: 78px;
    //     left: 20px;
    //     right: 20px;
    //     bottom: 0;
    // }
  }
}

/deep/.el-scrollbar__view {
  min-width: 100%;
}

/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}

/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}

/deep/ .el-card__body {
  padding: 0;
}

/deep/ .cell>div {
  text-align: center;
}

// /deep/ .el-date-editor > .el-range-input {
//   border: 1px solid #bbb;
// }
// /deep/ .el-input__inner > i {
//   width: 0;
// }</style>
